// extracted by mini-css-extract-plugin
export var banner_content = "index-module--banner_content--faa32";
export var banner_content_br = "index-module--banner_content_br--e0e85";
export var banner_cover = "index-module--banner_cover--11a99";
export var company_logo_item = "index-module--company_logo_item--90c38";
export var company_logos = "index-module--company_logos--1da8f";
export var honor_container = "index-module--honor_container--9e507";
export var honor_description = "index-module--honor_description--ed477";
export var honor_description_caption = "index-module--honor_description_caption--49727";
export var honor_item = "index-module--honor_item--cc7be";
export var honor_item_content = "index-module--honor_item_content--8c618";
export var honor_item_img = "index-module--honor_item_img--7995e";
export var honor_item_svg = "index-module--honor_item_svg--c33d2";
export var honor_items = "index-module--honor_items--0dae4";
export var honor_part = "index-module--honor_part--5aa22";
export var honor_title = "index-module--honor_title--8c83a";
export var honor_title_container = "index-module--honor_title_container--216b1";
export var logoMove = "index-module--logo-move--e2e77";
export var logo_container = "index-module--logo_container--2b851";
export var logo_container_wrapper = "index-module--logo_container_wrapper--3b40c";
export var statistics_part = "index-module--statistics_part--adaf2";